import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// Copyright 2019-2022 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Bridge } from '@polkadot/wasm-bridge';
import { createWasm } from '@polkadot/wasm-crypto-init';
export var bridge = new Bridge(createWasm);
export function initBridge(_x) {
  return _initBridge.apply(this, arguments);
}

function _initBridge() {
  _initBridge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(createWasm) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", bridge.init(createWasm));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _initBridge.apply(this, arguments);
}